import Axios from 'axios'
import moment from 'moment'

const userManagement = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.USER_MANAGEMENT
    return AxiosInstance
  },
  getMemberList() {
    return this.axios().get('/member/list')
  },
  getMemberStatus(username, cpf) {
    return this.axios().get(`/member/status?username=${username}&cpf=${cpf}`)
  },
  createMember(data) {
    return this.axios().post('/member', {
      name: data.stepUser.name,
      role: data.stepUser.role,
      cpf: data.stepUser.cpf,
      username: data.stepUser.email,
      password: data.stepUser.password,
      phone: data.stepUser.phone,
      birthday: moment(data.stepUser.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD')
    })
  },
  createMemberWithoutPassword(data) {
    return this.axios().post('/member', {
      name: data.stepUser.name,
      role: data.stepUser.role,
      username: data.stepUser.username,
      cpf: data.stepUser.cpf,
      phone: data.stepUser.phone,
      birthday: moment(data.stepUser.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD')
    })
  },
  activateMember(username) {
    return this.axios().put(`/member/status?username=${username}`)
  },
  getMemberById(id) {
    return this.axios().get(`/member/${id}`)
  },
  deleteMember(id) {
    return this.axios().delete(`/member/${id}`)
  },
  updateMember(data) {
    return this.axios().put(`/member/${data.stepUser.id}`, {
      name: data.stepUser.name,
      role: data.stepUser.role,
      username: data.stepUser.username,
      cpf: data.stepUser.cpf,
      phone: data.stepUser.phone,
      birthday: moment(data.stepUser.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      password: data.stepPassword.password || ''
    })
  },
  updateMemberNew(data) {
    return this.axios().put(`/member/${data.stepUser.id}`, {
      name: data.stepUser.name,
      role: data.stepUser.role,
      username: data.stepUser.username,
      cpf: data.stepUser.cpf,
      phone: data.stepUser.phone,
      birthday: moment(data.stepUser.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      password: data.stepPassword.password || ''
    })
  }
}

export default userManagement
